import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTree"><Path fillRule="evenodd" clipRule="evenodd" d="M3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 15.718 17.3696 19.5881 12.75 19.9692V22H11.25V19.9692C6.63035 19.5881 3 15.718 3 11ZM12 18.5C12.2531 18.5 12.5033 18.4875 12.75 18.463V15.3107L16.3107 11.75L15.25 10.6893L12 13.9393L9.75 11.6893L8.68934 12.75L11.25 15.3107V18.463C11.4967 18.4875 11.7469 18.5 12 18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTree;
